<template>
  <div style="padding: 10px; width: 100%">
    <div
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-top: 20px;
     "
    >
      {{ workDate | formatDate }}<i class="pi pi-calendar"></i>
    </div>
    <div>
      <b>{{ $t("WorkRegistrationForm.OtherTitle") }}</b>
    </div>
    <input
      type="text"
      class="searchInput"
      :placeholder="searchPlaceholder"
      v-model="searchText"
    />
    <!-- <div v-if="!searchText">
      <Accordion :multiple="true" v-if="!searchText">
        <AccordionTab header="Header I">
          <div
            v-for="activity in filteredActivities.filter(
              (item) => item.activityCode[0] == '2'
            )"
            :key="activity.id"
          >
            <button
              class="custom-mobile-button text-left"
              :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
              @click="addOtherActivity(activity)"
            >
              {{ activity.name }}
            </button>
          </div>
        </AccordionTab>
        <AccordionTab header="Header II">
          <div
            v-for="activity in filteredActivities.filter(
              (item) => item.activityCode[0] == '3'
            )"
            :key="activity.id"
          >
            <button
              class="custom-mobile-button text-left"
              :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
              @click="addOtherActivity(activity)"
            >
              {{ activity.name }}
            </button>
          </div>
        </AccordionTab>
        <AccordionTab header="Header III">
          <div
            v-for="activity in filteredActivities.filter(
              (item) => item.activityCode[0] == '4'
            )"
            :key="activity.id"
          >
            <button
              class="custom-mobile-button text-left"
              :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
              @click="addOtherActivity(activity)"
            >
              {{ activity.name }}
            </button>
          </div>
        </AccordionTab>
        <AccordionTab header="Header IV">
          <div
            v-for="activity in filteredActivities.filter(
              (item) => item.activityCode[0] == '5'
            )"
            :key="activity.id"
          >
            <button
              class="custom-mobile-button text-left"
              :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
              @click="addOtherActivity(activity)"
            >
              {{ activity.name }}
            </button>
          </div>
        </AccordionTab>
        <AccordionTab header="Header V">
          <div
            v-for="activity in filteredActivities.filter(
              (item) => item.activityCode[0] == '8'
            )"
            :key="activity.id"
          >
            <button
              class="custom-mobile-button text-left"
              :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
              @click="addOtherActivity(activity)"
            >
              {{ activity.name }}
            </button>
          </div>
        </AccordionTab>
        <AccordionTab header="Header VI">
          <div
            v-for="activity in this.filteredActivities.filter(
              (item) =>
                item.activityCode[0] != '2' &&
                item.activityCode[0] != '3' &&
                item.activityCode[0] != '4' &&
                item.activityCode[0] != '5' &&
                item.activityCode[0] != '8'
            )"
            :key="activity.id"
          >
            <button
              class="custom-mobile-button text-left"
              :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
              @click="addOtherActivity(activity)"
            >
              {{ activity.name }}
            </button>
          </div>
        </AccordionTab>
      </Accordion>
    </div> -->
    <div v-if="searchText">
      <div v-for="activity in filteredActivities" :key="activity.id">
        <button
          class="custom-mobile-button text-left"
          :style="activity.alreadyAdded ? 'background-color: #7aef7a' : ''"
          @click="addOtherActivity(activity)"
        >
          {{ activity.name }}
        </button>
      </div>
    </div>

    <button class="custom-mobile-button text-left" @click="addUnforeseen()">
      {{ $t("WorkRegistrationForm.UnforeseenAbsence") }}
    </button>
    <BackButton />
  </div>
</template>
<script>
import ActivityService from "../services/ActivityService";
import WorkDayService from "../services/WorkDayService";
import BackButton from "../components/common/BackButton";
import { formatDateServer } from "../utils";

export default {
  name: "ProjectOverview",
  components: { BackButton },
  props: {},
  workDayService: null,
  activityService: null,
  data() {
    return {
      activities: null,
      workDate: null,
      workDay: null,
      searchPlaceholder: this.$t("WorkRegistrationForm.SearchPlaceholder"),
      searchText: null,
      filteredActivities: null,
    };
  },
  created() {
    this.workDayService = new WorkDayService();
    this.activityService = new ActivityService();
    this.workDate = this.$route.query.workDate;
    this.getWorkDay();
  },
  watch: {
    searchText(val) {
      this.filteredActivities = this.activities.filter((activity) => {
        return activity.name.toLowerCase().includes(val.toLowerCase());
      });
    },
  },
  methods: {
    addOtherActivity(activity) {
      return this.$router.push({
        name: "add-other-activities",
        query: {
          workday: this.$route.query.workday,
          workDate: this.$route.query.workDate,
          isMidnight: this.$route.query.isMidnight,
          workDayId: this.$route.query.workDayId,
          workDayEndTime: this.$route.query.workDayEndTime,
          drivers: this.$route.query.drivers,
          activity: activity,
        },
      });
    },
    getWorkDay() {
      this.workDayService.getWorkDay(this.workDate).then((res) => {
        this.workDay = res.data;
        this.getActivityInfos();
      });
    },
    getActivityInfos() {
      this.activityService
        .getActivityInfos()
        .then((response) => {
          const result = response.data;
          if (result) {
            this.activities = result.map((s) => {
              return {
                id: s.id,
                name: s.name,
                descriptionRequired: s.descriptionRequired,
                remarks: s.remarks,
                defaultProjectId: s.defaultProjectId,
                isRecent: s.isRecent,
                activityCode: s.activityCode,
                alreadyAdded: false,
              };
            });
          }
          this.activities = this.activities.filter((activity) => {
            return activity.activityCode[0] != "1";
          });
          this.activities.forEach((activity) => {
            if (
              this.workDay.workRegistrations.find((wr) => {
                return wr.activityTypeId == activity.id;
              })
            ) {
              activity.alreadyAdded = true;
            } else {
              activity.alreadyAdded = false;
            }
          });
          this.filteredActivities = this.activities;
        })
        .catch(() => {});
    },
    addUnforeseen() {
      return this.$router.push({
        name: "add-unforeseen",
        query: {
          workday: this.workDay,
          workDate: formatDateServer(this.workDate),
          isMidnight: this.passMidnight,
          workDayId: this.workDay.id,
          workDayEndTime: this.workDay.endTime,
        },
      });
    },
  },
};
</script>
<style scoped>
.vdatetime >>> .vdatetime-input {
  width: 50%;
}
.div-field {
  margin-top: 10px;
  width: 100%;
}
.p-listbox {
  width: 100%;
}
.p-listbox-item {
  padding: 10px;
}
.p-inputtextarea {
  width: 100%;
}
.recent {
  color: #019ee9 !important;
}
.searchInput {
  width: 100%;
  padding: 10px;
  font-size: 20px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  z-index: 99;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
